import React from 'react';

import { Container, Heading, Span, Text } from './Stat.styled';

export interface Props {
    preheading?: string;
    postheading: string;
    citation?: string;
}

const Stat: React.FC<Props> = ({ preheading, postheading, citation }) => {
    return (
        <Container>
            <Heading>
                {preheading && preheading}
                <Span>{postheading}</Span>
            </Heading>
            {citation && <Text>{citation}</Text>}
        </Container>
    );
};

export default Stat;
